import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {LoadingService} from "../../services/LoadingService";
import {StateService} from "../../services/StateService";
import {State} from "../../models/State";
import {Router} from "@angular/router";
import {Session} from "../../services/Session";
import {TpFirmTodoService} from "../../tpiq-services/tp-firm-todo.service";

@Component({
  selector: 'app-dashboard-todos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-todos.component.html',
  styleUrl: './dashboard-todos.component.scss'
})
export class DashboardTodosComponent implements OnInit, OnDestroy {
  org: string = Session.getOrg();
  user: any = {};
  columns: Array<any> = [
    {name: 'clientName', title: 'Client', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
    {name: 'title', title: 'Name', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
    {name: 'dueDate', title: 'Due Date', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
    {name: 'priority', title: 'Priority', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
  ];
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  todosList: Array<any> = [];

  constructor(
    private _router: Router,
    private loadingService: LoadingService,
    private stateService: StateService,
    private todoService: TpFirmTodoService
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
    this.getTodosList();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getTodosList() {
    const data = {
      fromIndex : 0,
      status : "Assigned"
    };
    this.todoService.getFirmTodosTableData(this.org, this.user.id, data).subscribe(response => {
      this.todosList = response.toDosList;
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  navigateToTodoSinglePage(data) {
    this.stateService.addState(new State('DASHBOARD', this._router.url, null, null));
    const link = ['clients', data.clientId, data.clientName, 'toDo', data.id, 'singlepage'];
    this._router.navigate(link);
  }

}
